import request from './request'

export default {
  list(data) {
    return request.post('/videoCollection/list', data)
  },
  info(data) {
    return request.post('/videoCollection/info', data)
  },
  save(data) {
    return request.post('/videoCollection/save', data)
  },
  enable(data) {
    return request.post('/videoCollection/enable', data)
  },
  disable(data) {
    return request.post('/videoCollection/disable', data)
  },
  delete(data) {
    return request.post('/videoCollection/delete', data)
  },
  listByIds(data) {
    return request.post('/video/listByIds', data)
  },
}
